import './elements/hi-result-group';
import './elements/hi-placeholder';
import './elements/hi-timepicker';
import './elements/hi-typeahead';
import './elements/hi-pending';
import './elements/hi-result';
import './elements/hi-switch';
import './elements/hi-portal';
import './elements/hi-group';
import './elements/hi-case';
import './elements/hi-if';

export class ElementsArtifact {
  readonly id = 'old/elements/index';
  readonly crate = 'old/elements';
  readonly ns = 'old';
}

export default new ElementsArtifact();
